import React,{useContext} from 'react'
import { StyledNavbar } from './Navbar.styled'
import { NavButton } from '../Button/Button.styled'
import {AppContext} from "../../App"

function Navbar () {
    const toggleMenu = useContext(AppContext) 
  return (
    <StyledNavbar bColor = {"#fff"}>
      <p>Akintobi Ibukunoluwa </p>
      <NavButton onClick={toggleMenu}> Menu </NavButton>
      <div>
        <a href='#about'>About</a>
        <a href = "#projects">Projects</a>
       <a href = "#contact">Contact</a>
      </div>
    </StyledNavbar>
  );
}

export default Navbar
